import React from "react";

const MailReader = () => {
  return <div>MailReader</div>;
};

export default MailReader;
